import { createSelector } from '@ngrx/store';

import { selectFehSolarPanelsState } from '../feh-solar-panels.state';
import { solarPanelsFunnelKey } from './solar-panels-funnel.reducer';

export const selectSolarPanelsFunnelSettings = createSelector(
  selectFehSolarPanelsState,
  (state) => state[solarPanelsFunnelKey]
);
export const selectSelectedSolarPanelsProduct = createSelector(
  selectSolarPanelsFunnelSettings,
  ({ selectedProduct }) => selectedProduct
);
export const selectSolarPanelsTrackingId = createSelector(
  selectSolarPanelsFunnelSettings,
  ({ trackingId }) => trackingId
);
